<template>
  <div class="customer-goal">
    <div class="titulo">
      <Info title="Qual o seu objetivo ao usar o Padmoney?"/>
    </div>
    <div class="options">
      <div class="options-list destaque">
        <a class="option card-box" data-v-68efd0a6="" @click="$emit('change', 'charge')">
      <span class="icon">
       <img src="@/assets/img/quero-cobrar.png" alt="">
     </span>
          <span class="text">
      <p>Quero cobrar meus clientes</p>
    </span>
        </a>
        <p class="ou">ou</p>
        <a class="option botao cinza" @click="$emit('change', 'pay')">Quero pagar uma conta</a>
      </div>
    </div>
  </div>
</template>
<script>
import Info from '@/components/Info'

export default {
  name: 'CustomerGoal',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String
  },
  components: {
    Info
  },
  methods: {
    selectHandler(value) {
      this.$emit('change', value)
    }
  }
}

</script>
